"use client";
import { usercontext } from "@/lib/context";
import React, { useContext } from "react";
import { Avatar, Skeleton } from "antd";
import { IconGlobe } from "@/lib/icons";
import styles from "./Event/event.module.css";
const areTimezonesEqual = (tz1, tz2) => {
  if (!tz1 || !tz2) return false;
  const norm1 = tz1.toLowerCase().trim().replace("asia/calcutta", "asia/kolkata");
  const norm2 = tz2.toLowerCase().trim().replace("asia/calcutta", "asia/kolkata");
  return norm1 === norm2;
};

const EventTimezone = ({ timezone, UIfor }) => {
  const { timeZone: userTimeZone, timeLoading } = useContext(usercontext);
  if (timeLoading)
    return (
      <Skeleton.Button active className="!w-full border-b border-gray-100  !rounded-none py-[20px] px-[10px]" />
    );

  // The user's timezone is only resolved after mount (localStorage / ipapi),
  // so SSR and the first client render see undefined. Rendering the row then
  // made it flash and vanish on every refresh for same-timezone users.
  if (!userTimeZone) return null;

  const isSameTimezone = areTimezonesEqual(timezone, userTimeZone);

  if (isSameTimezone) return null;

  return (
    <div
      className={
        UIfor === "mobile" ? styles.eventSubdetail : styles.eventSummaryItem
      }
    >
      {UIfor === "mobile" ? (
        <></>
      ) : (
        <Avatar size={45} icon={<IconGlobe size={20} />} />
      )}
      <span>{timezone}</span>
    </div>
  );
};

export default EventTimezone;
